export const API_URL = "https://supplay.api.kmblabs.com";
export const API_KEY = "1c9id7L4ED7NPL0ZPOnj026QyLiBJYGl9l7Xp6TS";
